export const SET_LP_ALLOCATION = 'lp_allocation/SET_LP_ALLOCATION' as const
export const APPEND_LP_ALLOCATION = 'lp_allocation/APPEND_LP_ALLOCATION' as const
export const SET_ACTIVE_FILTERS = 'lp_allocation/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'lp_allocation/SET_ACTIVE_SORTING' as const
export const UPDATE_LP_ALLOCATION_ROW = 'lp_allocation/UPDATE_LP_ALLOCATION_ROW' as const
